import React, { useState } from 'react';
import { ListChecksIcon } from 'lucide-react';
import type { Finding } from '../../types/aus';
import { FindingRow } from './FindingRow';
interface FindingsListProps {
  findings: Finding[];
}
export function FindingsList({
  findings
}: FindingsListProps) {
  const [expandedId, setExpandedId] = useState<string | null>(null);
  return <section className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm" data-id="element-85" data-mp="22n42ettaaj9e">
      <header className="flex items-center justify-between gap-4 border-b border-slate-100 px-5 py-3.5" data-id="element-86" data-mp="1ewzzkonx6njg">
        <h3 className="flex items-center gap-2 text-sm font-semibold text-slate-900" data-id="element-87" data-mp="19zq6mz1bntqv">
          <ListChecksIcon aria-hidden="true" className="h-4 w-4 text-slate-400" data-id="element-88" data-mp="1nypsy01d3wjv" />
          Findings &amp; Messages
        </h3>
        <span className="text-xs text-slate-400" data-id="element-89" data-mp="2zcl8vb03c9c5">{findings.length} messages</span>
      </header>

      {findings.length === 0 ? <p className="px-5 py-8 text-center text-sm text-slate-500" data-id="element-90" data-mp="2ue9wasievkq8">
          No findings were returned for this submission.
        </p> : <ul className="divide-y divide-slate-100" data-id="element-91" data-mp="2bmit72eawbdy">
          {findings.map(finding => <FindingRow key={finding.id} finding={finding} expanded={expandedId === finding.id} onToggle={() => setExpandedId(expandedId === finding.id ? null : finding.id)} data-id="element-92" data-mp="2fo4enc4whxzr" />)}
        </ul>}
    </section>;
}